/**
 * Time formatting utilities
 */

/**
 * Formats seconds into HH:MM:SS format
 */
export function formatTime(seconds: number): string {
    if (seconds >= Number.MAX_SAFE_INTEGER) {
        return 'DNS/DNF';
    }
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Formats seconds into HH:MM format for axis labels
 */
export function formatTimeForAxis(seconds: number): string {
    if (seconds >= Number.MAX_SAFE_INTEGER) {
        return 'DNS/DNF';
    }
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}
